var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', [_vm.isPreloadCreation ? [_c('PreloaderOnCreation')] : [_c('div', {
    staticClass: "login-journal-wrapper"
  }, [_vm.hideBackground ? _c('style', {
    tag: "component"
  }, [_vm._v(" html body.promo-page { background-image: none !important; } ")]) : _vm._e(), _c('preloader'), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v(" (function (m, e, t, r, i, k, a) { m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments) }; m[i].l = 1 * new Date(); k = e.createElement(t), a = e.getElementsByTagName(t)[0], k.async = 1, k.src = r, a.parentNode.insertBefore(k, a) }) (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\"); window.ym(56121682, \"init\", { clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true }); ")]), _vm._m(0), _c('div', {
    staticClass: "main-container-wrapper _promo-container"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }), _c('div', {
    staticClass: "main-container"
  }, [_vm.step !== 2.6 ? [_c('div', {
    staticClass: "enter-title"
  }, [_vm._v("Ваш личный гид в мире финансов")]), _vm._m(1)] : _vm._e(), _vm.step === 2.6 ? [_c('style', {
    tag: "component"
  }, [_vm._v(" html body.promo-page { padding-top: 0; } ")])] : _vm._e(), false ? [_vm.step === 2.7 ? [_vm._m(2)] : _vm._e(), _vm.step !== 2.6 ? [_c('div', {
    staticClass: "desc"
  }, [_vm.step !== 2.7 ? [_vm._v(" Финансовые статьи"), _c('br'), _vm._v(" и лайфхаки у вас в кармане ")] : _vm._e()], 2), _vm.step !== 2.7 ? _c('ul', {
    staticClass: "advantages"
  }, [_c('li', [_vm._v("коротко")]), _c('li', [_vm._v("уникально")]), _c('li', [_vm._v("актуально")])]) : _vm._e()] : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "input-containers",
    class: {
      'input-containers-error': _vm.response.type === 'error',
      'input-containers-gray': _vm.response.type === 'gray',
      'input-containers-complete': _vm.response.type === 'complete'
    },
    style: _vm.step === 2.6 ? {
      maxWidth: '460px'
    } : {}
  }, [_c('form', {
    staticClass: "login-form",
    attrs: {
      "autocomplete": "off"
    }
  }, [_vm.step === 1 ? [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Ваш телефон")]), _c('div', {
    staticClass: "input-container"
  }, [_c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '+7 ### ### ## ##',
      expression: "'+7 ### ### ## ##'"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }],
    staticClass: "text-input",
    attrs: {
      "id": "phone",
      "type": "tel",
      "placeholder": "+7 999 123 45 67"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value;
      }
    }
  })]), _vm.response.type === 'error' && _vm.response.message ? _c('div', {
    staticClass: "response-message"
  }, [_vm._v(" " + _vm._s(_vm.response.message) + " ")]) : _vm._e(), _c('div', {
    staticClass: "input-container"
  }, [_c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": "Перейти к чтению",
      "isLoading": _vm.preload,
      "isDisabled": _vm.preload || _vm.response.type === 'error'
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1)] : _vm._e(), _vm.step === 2 || _vm.step === 2.5 ? [_c('div', {
    staticClass: "input-container"
  }, [_c('label', {
    attrs: {
      "for": "code"
    }
  }, [_vm._v("Код из SMS")]), _c('input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '####',
      expression: "'####'"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }],
    staticClass: "text-input",
    class: {
      preload: _vm.preload
    },
    attrs: {
      "id": "code",
      "type": "text",
      "placeholder": "Введите код из SMS"
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-container"
  }, [_c('ButtonAction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length !== 4,
      expression: "code.length !== 4"
    }],
    staticClass: "main-action-btn",
    class: {
      'main-action-btn-disabled': _vm.codeSubmitDisabled
    },
    attrs: {
      "type": "submit",
      "message": _vm.codeSubmitButton,
      "isDisabled": _vm.codeSubmitDisabled
    },
    on: {
      "buttonAction": _vm.sendCode
    }
  }), _c('ButtonAction', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.code.length === 4,
      expression: "code.length === 4"
    }],
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.response.message || (_vm.step === 2 ? 'Продолжить' : 'Зарегистрироваться')
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/');
      }
    }
  }, [_vm._v("Вернуться назад")])])] : _vm._e(), _vm.step === 2.6 ? [_c('div', {
    attrs: {
      "id": "payment-form"
    }
  }), false ? _c('div', {
    staticClass: "input-container"
  }, [_c('a', {
    staticClass: "yandex-pay-cancel",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.yandexPayCancel($event);
      }
    }
  }, [_vm._v(" Отмена ")])]) : _vm._e()] : _vm._e(), _vm.step === 2.7 ? [_c('div', {
    staticClass: "input-container"
  }, [_c('a', {
    staticClass: "yandex-pay-start-read",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.startRead($event);
      }
    }
  }, [_vm._v(" Начать читать! ")])])] : _vm._e(), _vm.step === 3 ? [_c('div', {
    staticClass: "input-container"
  }, [_c('label', {
    staticClass: "label-step-3",
    attrs: {
      "for": "password"
    }
  }, [_vm.response.type === 'error' ? _c('span', [_vm._v("Пароль менее 6 символов")]) : _c('span', [_vm._v("Задайте пароль для входа не менее 6 символов")])]), _c('div', {
    staticClass: "input-group"
  }, [_c('InputHideShow', {
    attrs: {
      "hasError": _vm.response.type === 'error'
    },
    on: {
      "setPass": _vm.setPass
    }
  })], 1), _c('ButtonAction', {
    staticClass: "main-action-btn",
    attrs: {
      "type": "submit",
      "message": _vm.response.message || 'Войти'
    },
    on: {
      "buttonAction": _vm.handleSubmit
    }
  })], 1), _c('div', {
    staticClass: "_bottom"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.step = 1;
      }
    }
  }, [_vm._v("Вернуться назад")])])] : _vm._e()], 2)]), _c('div', {
    attrs: {
      "id": "change-phone"
    }
  }, [_vm._v("Изменить телефон")])], 2), _c('FooterAgreement', {
    on: {
      "setAgree": _vm.isAgree
    }
  })], 1)], 1)]], 2)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('noscript', [_c('div', [_c('img', {
    staticStyle: {
      "position": "absolute",
      "left": "-9999px"
    },
    attrs: {
      "src": "https://mc.yandex.ru/watch/56121682",
      "alt": ""
    }
  })])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "enter-caption"
  }, [_vm._v("Вход в кабинет / "), _c('br'), _vm._v("регистрация ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "yandex-pay-success"
  }, [_c('span', [_vm._v("Услуга успешно подключена!")]), _c('span', [_vm._v("Спасибо!")])]);
}]

export { render, staticRenderFns }